import { GET_DISCUSSION, DELETE_DISCUSSION } from "../constants";

const initialState = [];

export const groupDiscussionReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_DISCUSSION: {
            state = [...payload];
            return state;
        }
        case DELETE_DISCUSSION: {
            const { post, index, id } = payload
            if (post) {
                let temp = [...state];
                let del = temp[index]?.subcomment?.findIndex(post => post.id === id);
                if (del > -1) {
                    temp[index]?.subcomment?.splice(del, 1);
                }
                return temp
            } else {
                let temp = [...state];
                temp = temp.filter(post => post.id !== payload.id);
                return temp
            }

        }

        default: {
            return state
        }
    }
};